import { useContext, useState } from 'react'
import moment from 'moment'
import MODAL from 'src/utils/modals'
import { validationSchema } from './schema'
import { useHookForm } from 'src/hooks'
import { RootContext } from 'context/rootContext'
import { authenticate } from 'services/authenticationService'
import { DEFAULT_VALUES, ERROR_MESSAGES } from './constants'

const useLogin = () => {
  const context = useContext(RootContext)
  const [errorLogin, setErrorLogin] = useState(null)

  const siteRecaptchaKey = process.env.RECAPTCHA_SITE_KEY_LOGIN

  const handleLogin = async ({ data, captchaToken, failureCallback, successCallback }) => {
    const { email, password } = data
    const { isAuthenticated, user, authorization, response } = await authenticate({ email, password, captchaToken })
    if (isAuthenticated) {
      await context.setUser(user)
      if (successCallback) successCallback()
      return
    } else if (user) {
      const { firstName, lastName, document, homePhone, phone, birthDate, isNewsletterOptIn, isMktsrvTermsAccepted } = user
      context.setCredentials({
        email,
        authorization,
        password
      })
      context.toggleModalSheet(MODAL.CREATE_ACCOUNT({
        onCancel: () => context.toggleModalSheet({}, true),
        formData: {
          nameClient: [firstName, lastName].join(' ').trim(),
          documentCpf: document,
          phone: homePhone || phone,
          birthDate: birthDate ? moment(birthDate).format('DD/MM/YYYY') : undefined,
          isNewsletterOptIn,
          isMktsrvTermsAccepted,
          email
        }
      }))
    } else {
      const errorStatus = response.status
      setErrorLogin(ERROR_MESSAGES[errorStatus] ?? ERROR_MESSAGES.DEFAULT)
    }
    if (failureCallback) failureCallback()
  }

  const onSubmitForm = async (values, params) => {
    context.showLoader()
    const recaptcha = params.recaptchaRef.current
    const captchaToken = await recaptcha?.executeAsync()
    recaptcha.reset()
    await handleLogin({ data: values, captchaToken, failureCallback: params.failureCallback, successCallback: params.successCallback })
    context.hideLoader()
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema,
    defaultValues: DEFAULT_VALUES
  })

  return { form, siteRecaptchaKey, errorLogin }
}

export default useLogin
